import type { MantineSize, MantineTheme } from "@mantine/core";
import { getThemeColor, memoize, useMantineTheme } from "@mantine/core";
import type { ComponentPropsWithoutRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
type Size = MantineSize | string | number;

const resolveMantineSize = memoize((size: Size, theme: MantineTheme): string | number => {
  if (typeof size === "string" && ["xs", "sm", "md", "lg", "xl"].includes(size)) {
    return theme.fontSizes[size];
  }
  return size;
});

export type IconProps = {
  name: string;
  color?: string;
  size?: Size;
  variant?: "regular" | "light" | "solid" | "thin";
  fixedWidth?: boolean;
} & ComponentPropsWithoutRef<"span">;

export default function Icon({
  name,
  size = "sm",
  color = "inherit",
  variant = "regular",
  fixedWidth = false,
  ...props
}: IconProps) {
  const theme = useMantineTheme();

  const style = {
    ...props.style,
    fontSize: resolveMantineSize(size, theme),
    color: getThemeColor(color, theme)
  };

  return (
    <wa-icon
      fixed-width={fixedWidth}
      name={name}
      variant={variant}
      aria-label={`${name} icon`}
      {...props}
      style={style}
    ></wa-icon>
  );
}
